var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app-icon-svg__block"},[_c('svg',{staticClass:"app-icon-svg",style:(("width: " + _vm.width + "; fill: " + _vm.color + "; " + _vm.styleCss))},[_c('use',{attrs:{"xlink:href":("/img/sprite.svg#" + _vm.name)}})])])}
var staticRenderFns = []

export { render, staticRenderFns }